<template>
  <div>
    <div>
<!--      <el-card shadow="never">-->
<!--        <div style="display: flex;justify-content: space-between; align-items: center;width: 100%;">-->
<!--          <div style="display: inline-block;">-->
<!--            <el-badge is-dot class="item">快速筛选订单:</el-badge>-->
<!--            <el-badge value="14" class="item">-->
<!--              <el-button @click="changeIndex(0)" :class="{'selected1': selectedIndex ===0}" size="small">待处理</el-button>-->
<!--            </el-badge>-->
<!--            <el-badge value="30" class="item">-->
<!--              <el-button @click="changeIndex(1)" :class="{'selected1': selectedIndex ===1}" size="small">退款进行中</el-button>-->
<!--            </el-badge>-->
<!--            <el-badge value="14" class="item">-->
<!--              <el-button @click="changeIndex(2)" :class="{'selected1': selectedIndex ===2}" size="small">已完成</el-button>-->
<!--            </el-badge>-->
<!--            <el-badge value="30" class="item">-->
<!--              <el-button @click="changeIndex(3)" :class="{'selected1': selectedIndex ===3}" size="small">已拒绝</el-button>-->
<!--            </el-badge>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-card>-->
      <el-card shadow="never">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="申诉搜索">
            <el-input clearable style="width:250px;" v-model="formInline.keyWord" placeholder="请输入订单编号/售后编号/手机号/商品ID"></el-input>
          </el-form-item>
<!--          <el-form-item label="售后类型">-->
<!--            <el-select v-model="value" placeholder="请选择">-->
<!--              <el-option-->
<!--                  v-for="item in options"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="类型：">
            <el-select clearable v-model="formInline.type" placeholder="请选择">
              <el-option :value="4" label="全部"></el-option>
              <el-option :value="1" label="退款"></el-option>
              <el-option :value="2" label="退货"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="申诉时间">-->
          <!--            <el-date-picker-->
          <!--                v-model="formInline.value1"-->
          <!--                type="date"-->
          <!--                placeholder="请选择">-->
          <!--            </el-date-picker>-->
          <!--          </el-form-item>-->
          <el-form-item label="是否超过24小时未处理：">
            <el-select style="width:150px;" clearable  v-model="formInline.isNotAuditFor24">
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申诉时间">
            <el-date-picker
                v-model="value1"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handlePicker"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetSubmit">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="width:300px;display: inline-block;margin-right: 20px;">
          <el-button v-if="isApplyExport" size="medium" type="primary">导出</el-button>
        </div>
      </el-card>

      <el-card shadow="never">
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column
              label="订单号"
              width="180">
            <template slot-scope="scope">
              订单号:{{scope.row.thirdOrderId}}<br />
              外部单号:{{scope.row.childOrderNo}}
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="申诉时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="appealNo"
              label="申诉单号">
          </el-table-column>
          <el-table-column
              prop="reason"
              label="申诉原因">
          </el-table-column>
          <el-table-column
              width="250"
              label="申诉凭证">
            <template slot-scope="scope">
              <div>
                <img @click="handleLookBigPic(scope.row.pics)" style="width:200px;cursor: pointer;" :src="scope.row.pics">
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="申诉状态">
            <!--            0-提交申请，1-处理完成-->
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">提交申请</span>
              <span v-if="scope.row.status == 1">处理完成</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="auditChangeStatusName"
              label="平台处理结果">
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.businessStatus == 0">待审核</span>-->
<!--              <span v-if="scope.row.businessStatus == 1">通过</span>-->
<!--              <span v-if="scope.row.businessStatus == 2">拒绝</span>-->
<!--              <span v-if="scope.row.businessStatus == 3">完成</span>-->
<!--              <span v-if="scope.row.businessStatus == 4">关闭</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
              prop="auditNote"
              label="平台处理意见">
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.businessStatus == 0">待审核</span>-->
<!--              <span v-if="scope.row.businessStatus == 1">通过</span>-->
<!--              <span v-if="scope.row.businessStatus == 2">拒绝</span>-->
<!--              <span v-if="scope.row.businessStatus == 3">完成</span>-->
<!--              <span v-if="scope.row.businessStatus == 4">关闭</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
              width="200"
              label="商品信息">
            <template slot-scope="scoped">
              商品名称:{{scoped.row.skuName}} <br />
              品牌:{{scoped.row.brandName}}<br />
              品类:{{scoped.row.skuTypeName}}<br />
              型号:{{scoped.row.modelCode}}<br />
              规格:{{scoped.row.skuSpecs}}<br />
              规格属性:{{scoped.row.skuSpecsExt}}<br />
            </template>
          </el-table-column>
          <el-table-column
              width="200"
              label="下单信息">
            <template slot-scope="scoped">
              联系人:{{scoped.row.receiverName}}<br />
              联系电话:{{scoped.row.receiverPhone}}<br />
              收货地址:{{scoped.row.receiverProvinceName}}{{scoped.row.receiverCityName}}{{scoped.row.receiverDistrictName}}{{scoped.row.receiverAddress}}<br />
            </template>
          </el-table-column>
          <el-table-column
              prop="amount"
              label="订单金额">
          </el-table-column>
          <el-table-column
              prop="actualRefundAmount"
              label="退款金额">
          </el-table-column>
          <el-table-column
              prop="skuNumber"
              label="下单数量">
          </el-table-column>
          <el-table-column
              prop="applySkuNumber"
              label="售后数量">
          </el-table-column>
          <el-table-column
              label="售后类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">退款</span>
              <span v-if="scope.row.type == 2">退货</span>
              <span v-if="scope.row.type == 3">换货</span>
            </template>

          </el-table-column>
          <el-table-column
              prop="orderStatusName"
              label="发货状态">
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.status == 10">待支付</span>-->
<!--              <span v-if="scope.row.status == 20">备货中</span>-->
<!--              <span v-if="scope.row.status == 30">待收货</span>-->
<!--              <span v-if="scope.row.status == 40">已收货</span>-->
<!--              <span v-if="scope.row.status == 50">已完成</span>-->
<!--              <span v-if="scope.row.status == 60">已取消</span>-->
<!--              <span v-if="scope.row.status == 70">已关闭</span>-->
<!--            </template>-->
          </el-table-column>
<!--          <el-table-column-->
<!--              label="售后状态">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.handleStatus == 0">待处理</span>-->
<!--              <span v-if="scope.row.handleStatus == 1">进行中</span>-->
<!--              <span v-if="scope.row.handleStatus == 2">已完成</span>-->
<!--              <span v-if="scope.row.handleStatus == 3">已取消</span>-->
<!--              <span v-if="scope.row.handleStatus == 4">已拒绝</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
              prop="businessStatusName"
              label="售后状态">
          </el-table-column>
          <el-table-column
              prop="businessRejectReason"
              label="驳回原因">
          </el-table-column>
          <el-table-column
              fixed="right"
              align="center"
              width="300"
              label="操作">
            <template slot-scope="scope">
              <div>
                <el-button @click="goDetails(scope.row)" v-if="isApplyDetail" size="mini" type="success">查看详情</el-button>
              </div>
              <!--              dealApply-->
<!--              <div>-->
<!--                <el-button @click="dealApply(scope.row)" v-if="isApplyDetail" size="mini" type="success">处理</el-button>-->
<!--              </div>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
        </el-pagination>
      </el-card>
    </div>
    <el-dialog width="50%" :visible.sync="isShowBigPic">
      <img :src="bigPic" style="width: 100%; height:100%;">
    </el-dialog>
    <el-dialog
        :show-close = false
        v-if="dialogVisible"
        title="申诉审核"
        :visible.sync="dialogVisible"
        width="40%"
        :before-close="handleClose">
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="申诉审核" prop="desc">
          <el-input
              width="400px;"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入内容"
              v-model="ruleForm.AuditNote">
          </el-input>
        </el-form-item>
        <el-form-item label="是否变更售后状态">
          <el-radio-group v-model="ruleForm.AuditChangeStatus">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-button size="mini" type="success" v-if="ruleForm.AuditChangeStatus == '1'">变为更待处理状态</el-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" v-prevent-click @click="submitForm">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import {getButtonList} from "../../../promissionRouter";
import {OrderAfterSaleAppealList, OrderAfterSaleAuditAppeal} from "../../../api/api";

export default {
  name: "RefundGoods",
  data(){
    return {
      ruleForm:{
        AppealId:null,
        AuditNote:'',
        AuditChangeStatus:0
      },
      dialogVisible: false,
      loading: false,
      value1:[],
      isShowBigPic: false,
      bigPic: null,
      options: [{
        value: '0',
        label: '全部'
      }, {
        value: '1',
        label: '退款'
      }, {
        value: '2',
        label: '退货'
      }, {
        value: '3',
        label: '换货'
      }, {
        value: '4',
        label: '退款/退货'
      }],
      value: '',
      isApplyExport:false,
      isApplyDetail:false,
      tableData:[],
      selectedIndex: 1,
      formInline: {
        keyWord: '',
        type:4,
        pageIndex:1,
        isNotAuditFor24:null,
        pageSize:10,
        AppealTimeStart:'',
        AppealTimeEnd:'',
        // HandleStatus: 0,
      },
      total: 0,
    }
  },
  mounted() {
    // const myScroll = new IScroll('#scroll', {
    //   //按照需求添加横向滚动的配置项
    // });
    //更新
    // console.log('myScroll',myScroll)
    // myScroll.refresh();

    // this.getSpusOnSale();
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    console.log('button', buttonList)
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      if (this.buttonList_toolBar && this.buttonList_toolBar.length > 0){
        this.buttonList_toolBar.forEach((item,index) =>{
          if (item.func === "applyExport") {
            this.isApplyExport = true;
          }
        })
      }
      console.log(toolBarButtonList,'toolBarButtonList')
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      if (this.buttonList_table && this.buttonList_table.length > 0){
        this.buttonList_table.forEach((item,index) =>{
          if (item.displayName === "详情") {
            this.isApplyDetail = true;
          }
        })
      }
    }
    // console.log('buttonList', buttonList)
    // console.log('toolBarButtonList', this.buttonList_toolBar)
    // console.log('buttonList_table', this.buttonList_table)
  },
  created(){
    this.getList();
  },
  methods: {
    async submitForm(){
      let res = await OrderAfterSaleAuditAppeal(this.ruleForm)
      if (res.data.success) {
        this.$message.success(res.data.msg)
        this.dialogVisible = false;
      }else{
        this.$message.error(res.data.msg)
      }
      console.log(res);
    },
    resetForm(){},
    handleClose(){},
    dealApply(row){
      this.ruleForm.AppealId = row.AppealId;
      this.ruleForm.AuditNote = row.AuditNote;
      this.ruleForm.AuditChangeStatus = row.AuditChangeStatus;
      this.dialogVisible = true;

    },
    handlePicker(date) {
      this.formInline.AppealTimeStart = date[0];
      this.formInline.AppealTimeEnd = date[1];
    },
    handleLookBigPic(url) {
      if(!url) return this.$message.error('暂无图片');
      this.bigPic = url;
      this.isShowBigPic = true;
    },
    async getList(){
      this.loading = true;
      let res = await OrderAfterSaleAppealList(this.formInline);
      console.log('res', res)
      if (res.data.success) {
        this.loading = false;
        this.tableData =res.data.result.data.data;
        this.total = res.data.result.data.dataCount;
      }else {
        this.loading = false;
        this.$message.error(res.data.msg)
      }
    },
    goDetails(row){
      // this.$router.push(`/AfterSalesService/ApplyList/Detail?afterSaleOrderId=${row.afterSaleOrderId}`)
      this.$router.push(`/AfterSalesService/AfterSaleList/Detail?afterSaleOrderId=${row.afterSaleOrderId}`)
    },
    refuse(){
      this.$confirm("确认拒绝退货吗?", "提示", {
        closeOnClickModal: false,
        //type: 'warning'
      })
          .then(() => {

          })
          .catch((err) => {
            console.log(err)
          });
    },
    refundGoods(){
      this.$confirm("确认退货吗?", "提示", {
        closeOnClickModal: false,
        //type: 'warning'
      })
          .then(() => {

          })
          .catch((err) => {
            console.log(err)
          });
    },
    changeIndex(i){
      this.selectedIndex = Number(i);
      this.formInline.HandleStatus = Number(i);
      this.getList();
    },
    resetSubmit(){
      this.value1 = [];
      this.formInline = {
        keyWord: '',
        type:4,
        pageIndex:1,
        isNotAuditFor24:null,
        pageSize:10,
        AppealTimeStart:'',
        AppealTimeEnd:'',
      };
      this.getList();
    },
    onSubmit() {
      console.log('submit!');
      this.getList();
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.formInline.pageIndex = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val
      this.getList()
    },
  }
}
</script>



<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
/deep/ .selected1 {
  background-color: #ecf5ff;
  color:#409eff;
}
.pagination {
  text-align: right;
  margin-top: 15px;
}
</style>